const filtersData = [
  {
    name: 'type',
    label: 'Тип',
    options: [
      { name: 'products', label: 'Продукт' },
      { name: 'part', label: 'Запчасть' },
      { name: 'accessory', label: 'Аксессуар' },
    ],
  },
  {
    name: 'brand',
    label: 'Бренд',
    options: [
      { name: 'Tefal', label: 'Tefal' },
      { name: 'Moulinex', label: 'Moulinex' },
      { name: 'Rowenta', label: 'Rowenta' },
      { name: 'Krups', label: 'Krups' },
      { name: 'Seb', label: 'Seb' },
    ],
  },
  {
    name: 'category',
    label: 'Категория',
    options: [
      { name: 'Кухонные комбайны', label: 'Кухонные комбайны' },
      { name: 'Блендеры', label: 'Блендеры' },
      { name: 'Миксеры', label: 'Миксеры' },
      { name: 'Кофемашины', label: 'Кофемашины' },
      { name: 'Мультиварки', label: 'Мультиварки' },
      { name: 'Фритюрницы', label: 'Фритюрницы' },
      { name: 'Грили и барбекю', label: 'Грили и барбекю' },
      { name: 'Тостеры', label: 'Тостеры' },
      { name: 'Электрочайники', label: 'Электрочайники' },
      { name: 'Пылесосы', label: 'Пылесосы' },
      { name: 'Фены', label: 'Фены' },
      { name: 'Утюги', label: 'Утюги' },
      { name: 'Парогенераторы', label: 'Парогенераторы' },
      { name: 'Паровые швабры', label: 'Паровые швабры' },
      {
        name: 'Вентиляторы и обогреватели',
        label: 'Вентиляторы и обогреватели',
      },
      { name: 'Мясорубки', label: 'Мясорубки' },
      { name: 'Микроволновые печи', label: 'Микроволновые печи' },
      { name: 'Измельчители', label: 'Измельчители' },
      { name: 'Пароварки', label: 'Пароварки' },
    ],
  },
];

const catalogData = {
  count: '13 025',
  showCount: '1 - 20',
  pages: 20,
  items: [
    {
      article_number: '1210034953',
      commercial_number: 'EA843803/70B',
      name: 'EXPRESSO FALCON III',
      brand: 'Krups',
      category: 'Кофемашины',
      status: 'active',
      type: 'model',
      model: 'BL1234',
      image: '',
      analoges: 'TS-0103940',
      in_stoke: true,
    },
    {
      article_number: '1210034954',
      commercial_number: 'EA843803/70B',
      name: 'EXPRESSO FALCON III',
      brand: 'Krups',
      category: 'Кофемашины',
      status: 'discontinued',
      type: 'model',
      model: 'BL1234',
      image: '',
      analoges: '',
      in_stoke: true,
    },
    {
      article_number: '1210034955',
      commercial_number: 'EA843803/70B',
      name: 'EXPRESSO FALCON III',
      brand: 'Krups',
      category: 'Кофемашины',
      status: 'replacement',
      type: 'model',
      model: 'BL1234',
      image: '',
      analoges: '',
      in_stoke: true,
    },
    {
      article_number: '1210034956',
      commercial_number: 'EA843803/70B',
      name: 'EXPRESSO FALCON III',
      brand: 'Krups',
      category: 'Кофемашины',
      status: 'active',
      type: 'detail',
      model: 'BL1234',
      image: '',
      analoges: '',
      in_stoke: false,
    },
    {
      article_number: '1210034957',
      commercial_number: 'EA843803/70B',
      name: 'EXPRESSO FALCON III',
      brand: 'Krups',
      category: 'Кофемашины',
      type: 'accessory',
      model: 'BL1234',
      image: '',
      analoges: '',
      in_stoke: true,
    },
  ],
};

export { filtersData, catalogData };
